/**
 * Preferencia de "sidebar expandido" compartida por los layouts.
 *
 * Regla: en pantallas menores a {@link SIDEBAR_BREAKPOINT} el sidebar SIEMPRE
 * arranca expandido (el riel de solo iconos no es usable ahí y el usuario espera
 * ver los nombres la primera vez). En escritorio se respeta la preferencia
 * guardada por el usuario; y esa preferencia solo se persiste desde escritorio
 * para no ensuciarla con un colapso hecho en móvil.
 */
export const SIDEBAR_BREAKPOINT = 1280;

const STORAGE_KEY = 'sidebar-expanded';

const isSmallScreen = (): boolean =>
  typeof window !== 'undefined' && window.innerWidth < SIDEBAR_BREAKPOINT;

/**
 * Estado inicial de `sidebarExpanded`.
 *
 * @param desktopFallback valor en escritorio cuando el usuario aún no eligió.
 */
export const getInitialSidebarExpanded = (desktopFallback = true): boolean => {
  if (isSmallScreen()) return true;
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === null ? desktopFallback : stored === 'true';
  } catch {
    return desktopFallback;
  }
};

/** Persiste la preferencia (solo desde escritorio). */
export const persistSidebarExpanded = (expanded: boolean): void => {
  if (isSmallScreen()) return;
  try {
    localStorage.setItem(STORAGE_KEY, String(expanded));
  } catch {
    /* almacenamiento no disponible */
  }
};
